import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavController} from '@ionic/angular';
import { NavigationService } from 'src/providers/navigation/navigation.service';

/**
 * Generated class for the TextCookiesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-text-cookies',
  templateUrl: 'text-cookies.html',
  styleUrls:['./text-cookies.scss']
})
export class TextCookiesPage {
  previousUrl:string;

  constructor(
    public navCtrl: NavController, 
    public router:Router,
    public navService: NavigationService
  ) {
    this.previousUrl = this.navService.getPreviousUrl();
    console.log('previousUrl', this.previousUrl)
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter TextCookiesPage');
  }

}
